module.exports = __webpack_public_path__ + "static/media/IconDetailView.4e859bed.svg";